import { memo } from 'react';
import { Box, Image, Text, Button } from '@bonanza-social/moonlight';
import { useNavigation } from '@bonanza-social/navigation';

function SOFSent() {
  const navigation = useNavigation();

  return (
    <Box
      flex={1}
      gap="space-400"
      paddingHorizontal="space-400"
      alignItems="center"
      justifyContent="center"
    >
      <Image name="common.success" width={80} height={80} />
      <Text
        variant="h5"
        locNS="account"
        locKey="SOFSentTitle"
        color="darkSurfacePrimary"
        textAlign="center"
      />
      <Text
        variant="body-m"
        locNS="account"
        locKey="SOFSentDescription"
        color="darkSurfacePrimary"
        textAlign="center"
      />
      <Button
        variant="secondary"
        onPress={navigation.popToTop}
        locNS="common"
        locKey="goHome"
        width="100%"
      />
    </Box>
  );
}

export default memo(SOFSent);
